import React, { useState, useEffect } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment/moment';
import { useLocation } from 'react-router-dom';

//Components
import MainCard from '../../components/MainCard/MainCard';
import TextField from '../../components/TextField/TextField';
import TabelaListagem from '../../components/TabelaListagem/TabelaListagem';
import FichaMTR from './FichaMTR';
import Loading from 'components/Loading/Loading';

//Api
import MTR_api from '../../api/MTR_api';
import destino_api from '../../api/destino_api';
import gerador_api from '../../api/gerador_api';
import transportador_api from '../../api/transportador_api';
import modalidadeColeta_api from '../../api/modalidadeColeta_api';
import prefeitura_api from '../../api/prefeitura_api';

//Helpers
import { showMessage } from '../../helpers/message';

//Constants
import { actionsTable } from '../../constants/MaterialTable';
import { useAuth } from 'context/auth';

//Estado inicial dos filtros
function initialStateFiltros() {
    const dataFim = new Date();
    const dataInicio = new Date();
    dataInicio.setMonth(dataFim.getMonth() - 1);

    return {
        idMTR: "",
        tbTipoColeta_Id: "",
        tbTipoColeta_Id_Selected: null,
        tbTransportadores_Id: "",
        tbTransportadores_Id_Selected: null,
        tbDestino_Id: "",
        tbDestino_Id_Selected: null,
        tbGerador_Id: "",
        tbGerador_Id_Selected: null,
        status: "Todos",
        status_Selected: null,
        dataInicio: moment(dataInicio).format("YYYY-MM-DD"),
        dataFim: moment(dataFim).format("YYYY-MM-DD"),
    }
}

export default function PesquisaMTR() {
    //Location para pegar o state de filtros caso tenha
    const location = useLocation();

    //context
    const { session, setupVariavel } = useAuth();

    //Modalidades de coleta para o select
    const [modalidades, setModalidades] = useState([]);

    //Transportadores para o select
    const [transportadores, setTransportadores] = useState([]);

    //Geradores para o select
    const [geradores, setGeradores] = useState([]);

    //Destinos para o select
    const [destinos, setDestinos] = useState([]);

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle de exibição dos filtros
    const [openFiltros, setOpenFiltros] = useState(false);

    //Função que faz a troca de exibição do formulario de filtros na tela
    const toggleFiltros = () => setOpenFiltros(!openFiltros);


    //Estado de controle de exibição da ficha da mtr
    const [ficha, setFicha] = useState(false);

    //Estado que guarda a lista das mtrs
    const [mtrs, setMtrs] = useState([]);

    //Estado que guarda os filtros possiveis para a lista de mtrs
    const [filtros, setFiltros] = useState(location.state && location.state.filtros ? location.state.filtros : initialStateFiltros);

    //Opções do select de status
    const statusOptions = [
        { label: "Todos", value: "Todos" },
        { label: "Em Transito", value: "Em Transito" },
        { label: "Coleta Parcial", value: "Coleta Parcial" },
        { label: "Coleta Total", value: "Coleta Total" },
        { label: "Descarregado", value: "Descarregado" },
        { label: "Finalizada", value: "Finalizada" },
    ]

    //Cabeçalhos da tabela
    const headers = [
        { value: "Status", objectValue: "status", align: "left" },
        { value: `Numero da ${setupVariavel?.siglaDocumentoColeta}`, objectValue: "codigoMTR", align: "right" },
        { value: "Data programação", objectValue: "dataProgramada" },
        { value: "Modalidade de coleta", objectValue: "modalidade", align: "left" },
        { value: "Gerador", objectValue: "gerador", align: "left" },
        { value: "Data/Hora coleta", objectValue: "dataColetada" },
        { value: "Transportador", objectValue: "transportador", align: "left" },
        { value: "Destino", objectValue: "destino", align: "left" },
    ]

    //Carrega a lista de mtrs no inicio do componente
    const loadMtrs = () => {

        if (session && session.acesso.sigla === "GS" && filtros.tbTransportadores_Id == "" && filtros.tbDestino_Id == "" && filtros.tbGerador_Id == "") {
            showMessage("Aviso", "Selecione um transportador, destino ou gerador para filtrar!", "warning", null);
            return;
        }
        if (new Date(filtros.dataInicio).getTime() >= new Date(filtros.dataFim).getTime()) {
            showMessage("Aviso", "A data de inicio tem que estar antes da data de fim do intervalo!", "warning", null);
            return;
        }
        setLoading(true);
        const _filtros = { ...filtros };
        _filtros.dataFim = _filtros.dataFim + " 23:59:59";
        MTR_api.GetList(_filtros).then(response => {
            response.data = response.data.map(value => {
                Object.keys(value).map(key => {
                    if (value[key] != null && (value[key].toString().indexOf(".") != -1 && typeof value[key] == "number") || key == "volumeColetado" || key == "volume") {
                        value[key] = value[key].toFixed(2);
                        value[key] = value[key].toString();
                        value[key] = value[key].replace('.', ',');
                    }
                });
                return value;

            });
            setMtrs(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => {
            setLoading(false);
        })
    }

    //Carrega os transportadores do filtro
    const loadTransportadores = () => {
        transportador_api.GetAll().then(response => {
            response.data = response.data.map(value => {
                return { label: value.fantasia, value: value.id }
            })
            setTransportadores(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        });
    }

    //Carrega os geradores do filtro
    const loadGeradores = () => {
        prefeitura_api.GetList().then(response => {
            gerador_api.GetList(response.data[0].id).then(response => {
                response.data = response.data.map(value => {
                    return { label: value.fantasia, value: value.id }
                });
                setGeradores(response.data);
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            });
        });
    }

    //Carrega as modalidades de coleta do filtro
    const loadModalidades = () => {
        modalidadeColeta_api.GetList().then(response => {
            response.data = response.data.map(value => {
                return { label: value.descricao, value: value.id }
            })
            setModalidades(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        })
    }

    //Carrega os destinos do filtro
    const loadDestinos = () => {
        destino_api.GetList().then(response => {
            response.data = response.data.map(value => {
                return { label: value.fantasia, value: value.id }
            });
            setDestinos(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        })
    }

    //Carrega os dados do filtro de acordo com o modulo acessado
    const loadDadosFiltros = () => {
        switch (session && session.acesso.modulo) {
            case "Destino": {
                loadTransportadores();
                loadGeradores();
                loadModalidades();
                break;
            }
            case "Gestor": {
                loadTransportadores();
                loadGeradores();
                loadModalidades();
                loadDestinos();
                break;
            }
            case "Transportador": {
                loadGeradores();
                loadModalidades();
                loadDestinos();
                break;
            }
            case "Gerador": {
                loadTransportadores();
                loadModalidades();
                loadDestinos();
                break;
            }
        }
    }
    useEffect(() => {
        if (session && session.acesso.sigla !== "GS") {
            loadMtrs();
        }
        loadDadosFiltros();
    }, []);

    //Change para os selects com pesquisa
    const onChangeSearchSelect = (e, select) => {
        setFiltros({
            ...filtros,
            [select.name]: e,
            [select.name.replace("_Selected", "")]: e == null ? "" : e.value
        })
    }

    //Change dos campos de data
    const onChangeDateInput = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        })
    }

    //Controle de exibição de ficha
    if (ficha) {
        return <FichaMTR btnVoltar={() => {
            loadMtrs();
            setFicha(false);

        }} filtros={filtros} mtrParam={ficha} />
    }

    //Ações da tabela de listagem
    const actions = [
        actionsTable.visualizar((item) => setFicha(item))
    ]

    return (
        <MainCard noCard btnFiltros={toggleFiltros}>
            {loading && <Loading />}
            <div className={`filtros ${openFiltros ? "" : "close"} mb-4`}>

                <Row>
                    <Col lg={"4"} md="6" sm="12">
                        <TextField label="Modalidade de coleta" type={"select"} searchable name={"tbTipoColeta_Id_Selected"} onChange={onChangeSearchSelect} value={filtros.tbTipoColeta_Id_Selected} options={modalidades} />
                    </Col>
                    {session && session.acesso.sigla != "TR"
                        ?
                        <Col lg={"4"} md="6" sm="12">
                            <TextField label="Transportador" type={"select"} searchable name={"tbTransportadores_Id_Selected"} onChange={onChangeSearchSelect} value={filtros.tbTransportadores_Id_Selected} options={transportadores} />
                        </Col>
                        : <></>}
                    {session && session.acesso.sigla != "GG"
                        ?
                        <Col lg={"4"} md="6" sm="12">
                            <TextField label="Gerador" type={"select"} searchable name={"tbGerador_Id_Selected"} onChange={onChangeSearchSelect} value={filtros.tbGerador_Id_Selected} options={geradores} />
                        </Col>
                        : <></>}
                    {session && session.acesso.sigla != "DS"
                        ?
                        <Col lg={"4"} md="6" sm="12">
                            <TextField label="Destino" type={"select"} searchable name={"tbDestino_Id_Selected"} onChange={onChangeSearchSelect} value={filtros.tbDestino_Id_Selected} options={destinos} />
                        </Col>
                        : <></>}
                    <Col lg={"4"} md="6" sm="12">
                        <TextField label="Status" type={"select"} searchable name={"status_Selected"} onChange={onChangeSearchSelect} value={filtros.status_Selected} options={statusOptions} />
                    </Col>
                    <Col lg={"4"} md="6" sm="12">
                        <TextField label="Início" type={"date"} name={"dataInicio"} onChange={onChangeDateInput} value={filtros.dataInicio} />
                    </Col>
                    <Col lg={"4"} md="6" sm="12">
                        <TextField label="Fim" type={"date"} name={"dataFim"} onChange={onChangeDateInput} value={filtros.dataFim} />
                    </Col>
                </Row>
                <div className='mt-3 ms-3'>
                    <Button className='fw-bold' color='info' style={{ color: "#fff" }} onClick={() => loadMtrs()}>
                        <FontAwesomeIcon className='me-2' icon={faSearch} /> Pesquisar
                    </Button>
                </div>
            </div>
            <TabelaListagem actions={actions} headers={headers} items={mtrs} title={`Lista de ${setupVariavel?.siglaDocumentoColeta}s`} options={{ print: false, search: true, pagination: true }} />
        </MainCard>
    )
}